module.exports = __webpack_public_path__ + "static/img/davis_pictgrid46_960x847.2d1e347.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid46_960x847.jpg
// module id = xksJ
// module chunks = 0